module.exports = __webpack_public_path__ + "img/nosort.4e4a65d5.svg";